import React from "react";
import { cn } from "@udecode/cn";
import {
  createNodeHOC,
  createNodesHOC,
  PlaceholderProps,
  usePlaceholderState,
} from "@udecode/plate-common";
import { ELEMENT_H1, ELEMENT_H2 } from "@udecode/plate-heading";
import { ELEMENT_PARAGRAPH } from "@udecode/plate-paragraph";
import { useReadOnly } from "../new-editor/hooks";

export const PARAGRAPH_PLACEHOLDER =
  "Type a paragraph, or press '/' for commands";

export const Placeholder = (props: PlaceholderProps) => {
  const { children, placeholder, nodeProps } = props;

  const { enabled } = usePlaceholderState(props);
  const readonly = useReadOnly();

  return React.Children.map(children, (child) => {
    return React.cloneElement(child, {
      className: child.props.className,
      nodeProps: {
        ...nodeProps,
        className: cn(
          enabled &&
            !readonly &&
            // hide [...data-slate-placeholder...] when placeholder is shown
            // otherwise it overlaps with the custom placeholder
            "before:absolute before:cursor-text before:opacity-30 before:content-[attr(placeholder)] [&_span[data-slate-placeholder]]:!opacity-0",
        ),
        placeholder,
      },
    });
  });
};

export const withPlaceholder = createNodeHOC(Placeholder);
export const withPlaceholdersPrimitive = createNodesHOC(Placeholder);

export const withPlaceholders = (components: any) =>
  withPlaceholdersPrimitive(components, [
    {
      key: ELEMENT_PARAGRAPH,
      placeholder: PARAGRAPH_PLACEHOLDER,
      hideOnBlur: true,
      query: {
        maxLevel: null,
      },
    },
    {
      key: ELEMENT_H1,
      placeholder: "Type a heading",
      hideOnBlur: false,
    },
    {
      key: ELEMENT_H2,
      placeholder: "Type a heading",
      hideOnBlur: false,
    },
  ]);
